import {DialogContent} from "@material-ui/core";
import styled from "styled-components";

export const Disable2FADialogContent = styled(DialogContent)`
  padding-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center
`;